import { ConditionOperator, StringUtils } from "../../../../Global/Base/Utils/StringUtils";
//import {LazyLoadingSectionLogger, LoggingSection} from "@multiweb/logging";

//const logger = LazyLoadingSectionLogger.create(LoggingSection.dataGrid); // logger pro konkrétní oblast

/**
 * Třída pro usnadnění práce s výběrem záznamu
 */
export class SelectionHelper {
    /** Informace o tom, zda bylo vybrano vse uz pred aplikaci filtru */
    private _masterSelectAll: boolean;
    /** Informace o aktualnim vyberu vseho */
    private _isSelectAll: boolean;
    private _filterCondition: string;
    private _standardCondition: string;
    private _includedItems: Array<string> = [];
    private _excludedItems: Array<string> = [];
    /** Dodatecne vybrane zaznamy pomocí podmínky */
    private _selectedItemsByCond: string;

    private _currentCondition: string = "";
    private _finalConditions: Array<string> = [];
    public dataKey: string = "ID";

    private _log(_target: string): void {
        // logger.group(target);
        // {
        //     logger.info("masterSelectAll", this.masterSelectAll);
        //     logger.info("isSelectAll", this.isSelectAll);
        //     logger.info("inc items", this._includedItems);
        //     logger.info("excl items", this._excludedItems);
        //     logger.group("Conditions");
        //     {
        //         logger.info("BaseCondition", this.baseCondition);
        //         logger.info("CurrentCondition", this._currentCondition);
        //         logger.info("FilterCondition", this._filterCondition);
        //         logger.info("Final Condition List", this._finalConditions);
        //         logger.info("SelectedByCond", this._selectedItemsByCond);

        //     }
        //     logger.info("this", this);
        //     logger.groupEnd();
        // }
        // logger.groupEnd();
    }

    public set isSelectAll(v: boolean) {
        if (StringUtils.isNullOrEmpty(this.filterCondition)) {
            this._masterSelectAll = v;
            if (v) this._basicAllSelecetedClear();
        }

        if (this._isSelectAll != v) this._selectAll(v);
        this._isSelectAll = v;
        this._log("isSelectAll");
    }

    public get isSelectAll(): boolean {
        return this._isSelectAll;
    }

    /** Informace o tom, zda bylo vybrano vse uz pred aplikaci filtru */
    public get masterSelectAll(): boolean {
        return this._masterSelectAll;
    }

    public set filterCondition(v: string) {
        if (this._filterCondition == v) return;
        this._log("filterCondition");

        const oldFilter = this._filterCondition;
        this._finalizeCurrentCondition();
        this._filterCondition = v;

        this._createNewCurrentCondition(oldFilter);
    }

    public get filterCondition(): string {
        return this._filterCondition;
    }

    /**
     * Vratí standarntí podmínku zkombinovanou s filtrovací pokud je
     */
    public get baseCondition(): string {
        return StringUtils.combineConditions(ConditionOperator.and, this._standardCondition, this._filterCondition);
    }

    constructor(standardCondition: string, dataKey?: string) {
        this._standardCondition = standardCondition;
        this.dataKey = dataKey;
        this._createNewCurrentCondition();
    }

    /**
     * Přidá do výjmutých ŕádků
     * @param rows ID řádků
     */
    public exclude(rows: string[]): void {
        for (const row of rows) {
            const index = this._includedItems.indexOf(row);
            if (index != -1) {
                this._includedItems.splice(index, 1);
            }
            if ((this.isSelectAll || this._finalConditions.length > 0) && !this._excludedItems.includes(row)) this._excludedItems.push(row);
        }
        this._log("exclude");
    }

    /**
     * Přidá do zahrnutých řádků
     * @param rows ID řádků
     */
    public include(rows: string[]): void {
        for (const row of rows) {
            const index = this._excludedItems.indexOf(row);
            if (index != -1) {
                this._excludedItems.splice(index, 1);
            }
            if (!this.isSelectAll && !this._includedItems.includes(row)) this._includedItems.push(row);
        }
        this._log("include");
    }

    /**
     * Zjistí zda obsahuje ve výběru předané ID. Nezjištuje v podmínkách, v takovém případě vrací null
     * @param dataKey ID řádku
     */
    public contains(dataKey: string): boolean | null {
        if (this.isSelectAll) {
            if (this._excludedItems.includes(dataKey)) return false;
            return true;
        }
        if (this._includedItems.includes(dataKey)) return true;
        if (this._excludedItems.includes(dataKey)) return false;

        return null;
    }

    /**
     * Přepíše aktuální výběr předaným
     * @param rows ID řádků
     */
    public set(rows: string[]): void {
        this._basicAllSelecetedClear();
        this.add(rows);
    }

    /**
     * Přída nebo odebere z vybraných na základě nastavení isSelectedAlee
     * @param rows ID řádků
     */
    public add(rows: string[]): void {
        if (this.isSelectAll) {
            this.exclude(rows);
        } else {
            this.include(rows);
        }
    }

    /**
     * Odebere nebo přídá z vybraných na základě nastavení isSelectedAlee
     * @param rows ID řádků
     */
    public remove(rows: string[]): void {
        if (!this.isSelectAll) {
            this.exclude(rows);
        } else {
            this.include(rows);
        }
    }

    private _selectAll(newValue: boolean): void {
        if (!newValue) {
            this.clear();
        } else {
            if (StringUtils.isNullOrEmpty(this.filterCondition))
                this._clearIncEncItems();
        }
    }

    private _finalizeCurrentCondition(): void {
        let cond = "";
        if (!StringUtils.isNullOrEmpty(this._selectedItemsByCond)) cond = this._selectedItemsByCond;

        if (this.isSelectAll) {
            cond = StringUtils.combineConditions(ConditionOperator.and, this._currentCondition, cond);
        }

        this._selectedItemsByCond = "";
        this._currentCondition = "";
        //this._clearIncEncItems();
        this._createNewCurrentCondition();

        if (!StringUtils.isNullOrEmpty(cond)) this._finalConditions.push(cond);
    }

    /**
     * Vrátí finální podmínku
     */
    public buildCondition(): string {
        this._finalizeCurrentCondition();
        let cond = this._standardCondition;
        if (this._includedItems.length > 0) cond = `${this.dataKey} in { ${this._includedItems.join(",")} }`;
        if (this._excludedItems.length > 0) cond = StringUtils.combineConditions(ConditionOperator.and, cond, `not ( ${this.dataKey} in { ${this._excludedItems.join(",")} } )`);

        cond = StringUtils.combineConditionsArray(ConditionOperator.and, [cond, ...this._finalConditions]);

        return cond;
    }

    /**
     * Vrátí vybrané řádky, pokud je výběr složitější vrací je pomocí podmínky jinak vrátí pole dataKeys
     * @param forceCondition pokud je true, vždy vrací podmínku, výchozi false
     */
    public getSelectedData(forceCondition: boolean = false): string | Array<string> {
        if (forceCondition || (this.isSelectAll || this._finalConditions.length > 0 || !StringUtils.isNullOrEmpty(this._selectedItemsByCond))) {
            return this.buildCondition();
        } else {
            return Array.from(this._includedItems);
        }
    }

    private _createNewCurrentCondition(oldFilterCondition?: string): void {
        this._currentCondition = this.filterCondition; //this.baseCondition;
        if (this.isSelectAll) {
            if (this._masterSelectAll) {
                // Prázdné if
            } else { // pokud bylo vybrano vse, ale nebyl to globalni vyber vseho, musime pridat filtrovaci podminku do dalsiho vyberu
                this._isSelectAll = false;
                if (oldFilterCondition) this._selectedItemsByCond = oldFilterCondition;
            }
        }
    }

    private _clearIncEncItems(): void {
        this._excludedItems = [];
        this._includedItems = [];
    }

    private _basicAllSelecetedClear(): void {
        this._clearIncEncItems();
        this._selectedItemsByCond = null;
        this._finalConditions = [];
    }

    /**
     * Vyčistí veškeré výběry
     */
    public clear(): void {
        this._finalConditions = [];
        this._clearIncEncItems();
        this._filterCondition = "";
        this._currentCondition = "";
        this._selectedItemsByCond = "";

        this._createNewCurrentCondition();
    }
}
